module.exports = __webpack_public_path__ + "img/progress_070.77d0e901.png";